<template>
    <Button label="Добавить подписку" icon="pi pi-plus" class="flex" @click="showDialog" severity="info" size="small" />

    <Dialog
        class="flex flex-column border-none max-w-30rem p-0 m-0 xl:m-3 lg:m-2 md:m-1"
        modal
        v-model:visible="dialog"
        style="max-height:100%!important"
        :position="screenSize == 'xs' ? 'bottom' : 'right'"
        :style="dialogStyle"
        :contentStyle="contentStyle"
        :class="screenSize == 'xs' ? 'h-full border-noround-bottom' : ''"
    >
        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Добавить подписку</span>
            </div>
        </template>

        <div class="flex flex-column w-full h-full gap-3 overflow-auto">
            <div class="grid">
                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Клиент <span class="text-red-500">*</span>:</span>
                    <InputText v-model="form.client_id" class="w-full" placeholder="ID клиента" :disabled="loading" />
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Банк <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.payment_system_code" :options="banks_" optionLabel="label" optionValue="value" placeholder="Выберите банк" class="w-full" :loading="loading" />
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Сумма <span class="text-red-500">*</span>:</span>
                    <InputNumber v-model="form.amount" class="w-full" :minFractionDigits="0" :maxFractionDigits="2" :min="48" :max="3500" placeholder="100" :currency="form.currency" mode="currency" :disabled="loading" />
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Валюта <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.currency" :options="currencies" placeholder="Выберите валюту" class="w-full" :loading="loading" />
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Единица периода <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.period_unit" :options="periodUnits" placeholder="Выберите период" class="w-full" :loading="loading" />
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Количество периодов <span class="text-red-500">*</span>:</span>
                    <InputNumber v-model="form.period_count" class="w-full" :useGrouping="false" :min="1" placeholder="1" :disabled="loading" />
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Первая дата списания:</span>
                    <DatePicker v-model="form.first_charge_at" showTime hourFormat="24" fluid />
                </div>

                <div class="col-12 flex flex-column gap-2">
                    <span class="flex">Описание:</span>
                    <Textarea v-model="form.description" rows="3" autoResize :disabled="loading" />
                </div>
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap gap-2">
                <Button label="Добавить" @click="addSubscription" :loading="loading" class="flex" :disabled="loading || !canSubmit" severity="info" />
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex" autofocus severity="secondary" :disabled="loading" />
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'

const createInitialForm = () => ({
    client_id: '',
    payment_system_code: null,
    amount: null,
    currency: 'rub',
    period_unit: 'week',
    period_count: 1,
    description: '',
    first_charge_at: null,
})

export default {
    emits: ['added'],
    data() {
        return {
            loading: false,
            dialog: false,
            form: createInitialForm(),
            banks_: [
                {
                    value: 'aquaman',
                    label: 'Aquaman',
                },
            ],
        }
    },
    computed: {
        screenSize() {
            return this.$store.getters.StateScreenSize
        },
        dialogStyle() {
            return this.screenSize == 'xs' || this.screenSize == 'sm' || this.screenSize == 'md'
                ? { width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important' }
                : { width: '900px', height: '100%!important' }
        },
        contentStyle() {
            return this.screenSize == 'xs' || this.screenSize == 'sm' || this.screenSize == 'md'
                ? { height: '100%' }
                : { height: 'auto' }
        },
        currencies() {
            return ['RUB']
        },
        periodUnits() {
            return ['week', 'month', 'month3', 'month6', 'year']
        },
        canSubmit() {
            return Boolean(
                this.form.client_id &&
                this.form.payment_system_code &&
                this.form.amount !== null &&
                this.form.amount !== undefined &&
                this.form.currency &&
                this.form.period_unit &&
                this.form.period_count
            )
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity, summary, detail, life: 3000 })
        },
        showDialog() {
            this.dialog = true
        },
        resetForm() {
            this.form = createInitialForm()
        },
        formatDateForApi(value) {
            if (!value) return null
            const date = value instanceof Date ? value : new Date(value)
            if (Number.isNaN(date.getTime())) return null
            return date.toISOString()
        },
        buildPayload() {
            return {
                client_id: this.form.client_id,
                payment_system_code: this.form.payment_system_code,
                amount: Number(this.form.amount),
                currency: this.form.currency,
                period_unit: this.form.period_unit,
                period_count: Number(this.form.period_count),
                description: this.form.description || undefined,
                first_charge_at: this.formatDateForApi(this.form.first_charge_at),
            }
        },
        async addSubscription() {
            if (!this.canSubmit) {
                this.showMess('error', 'Ошибка', 'Заполните обязательные поля')
                return
            }

            this.loading = true
            try {
                const response = await this.connect.AddPersonalSubscription(this.buildPayload()).then(res => res)
                if (response && response.result) {
                    this.showMess('success', 'Успешно', 'Подписка добавлена')
                    this.dialog = false
                    this.resetForm()
                    this.$emit('added', response.data)
                } else {
                    this.showMess('error', 'Ошибка', response && response.message ? response.message : 'Ошибка при добавлении подписки')
                }
            } catch (error) {
                this.showMess('error', 'Ошибка', 'Ошибка при добавлении подписки')
            } finally {
                this.loading = false
            }
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
    }
}
</script>